// assets
import lightbulb from './assets/lightbulb.svg';
import danger from './assets/danger.png';
import trophy from './assets/trophy.png';
import lightningBolt from './assets/lightning-bolt.svg';
import info from './assets/info.svg';

interface AlertTipSizes {
  [index: string]: {
    image: string;
    text: 'md' | 'lg' | 'xl';
  };
}

export const sizes: AlertTipSizes = {
  sm: {
    image: '24px',
    text: 'md',
  },
  md: {
    image: '32px',
    text: 'md',
  },
  lg: {
    image: '48px',
    text: 'lg',
  },
};

export const variants = {
  lightbulb: {
    image: lightbulb,
  },
  info: {
    image: info,
  },
  danger: {
    image: danger,
  },
  trophy: {
    image: trophy,
  },
  lightningBolt: {
    image: lightningBolt,
  },
};
